import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';

// Utils
// @ts-ignore
import createDeepEqualSelector from 'utils/reselect/createDeepEqualSelector';

const selectDateRange = createDeepEqualSelector(
    [selectFirstDate, selectLastDate],
    (firstDate: string, lastDate: string) => {
        return { firstDate, lastDate };
    }
);

const makeSelectDateRange = (): typeof selectDateRange => selectDateRange;

export { makeSelectDateRange };
